import { useNavigate } from 'react-router-dom';
import { removeToken, getToken } from 'src/helpers/TokenHelper';
import { AuthService } from '../api/apiMms';

const useLogout = () => {
  const navigate = useNavigate();
  const afterLogout = (currentPath?: string) => {
    removeToken();
    //sessionStorage.removeItem('loginInfos');

    /*if (settings) {
      switch (settings.loginMode) {
        case 'oauth': {
          navigate(`/disconnected`);
          break;
        }
        default: {*/
    navigate(
      currentPath
        ? `/login?currentPath=${encodeURIComponent(String(currentPath))}`
        : `/login`
    );
    /*break;
        }
      }
    } else {
      navigate(`/login`);
    }*/
  };

  const logout = (currentPath?: string) => {
    AuthService.logout(getToken())
      .then(() => {
        afterLogout(currentPath);
      })
      .catch(() => {
        afterLogout(currentPath);
      });
  };

  // Return the generated classes
  return logout;
};

export default useLogout;
